import { Builder } from '@builder.io/react'
import dynamic from 'next/dynamic'

import { BLOCK_NAMES } from '@/legacy/blocks/blockNames'

Builder.registerComponent(
  dynamic<never>(() => import('.').then((mod) => mod.BlogVideoBlock)),
  {
    name: BLOCK_NAMES.blog.video,
    inputs: [
      {
        name: 'videoId',
        friendlyName: 'ID',
        helperText: 'Somente youtube, colocar o ID do vídeo.',
        type: 'string',
        required: true,
      },
      {
        name: 'width',
        type: 'string',
        hideFromUI: true,
      },

      {
        name: 'height',
        type: 'string',
        hideFromUI: true,
      },
    ],
  },
)
